import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000010004() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. H.E. Sim Sitha
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Chairman (Secretary of State Ministry of Industry Science Technology
            and Innovation)
          </Tooltip>
        </p>
        <p>
          2. H.E. Mey Vann
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Member (Secretary of State, Ministry of Economy and Finance)
          </Tooltip>
        </p>
        <p>
          3. H.E. Long Naro
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Member (Director General of PPWSA)
          </Tooltip>
        </p>
        <p>
          4. H.E. Nuon Pharat
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Member (Deputy Governor of the Board of Governors of Phnom Penh)
          </Tooltip>
        </p>
        <p>
          5. Mr. Ma Noravin
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Member (Representative of PPWSA's Employees)
          </Tooltip>
        </p>
        <p>
          6. Mr. Nam Channtry
          <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
            (g)
          </span>
          <Tooltip target=".g" position="right" event="both">
            Member (Non-Executive Director Representing Private Shareholder)
          </Tooltip>
        </p>
        <p>
          7. Mr. Sreng Samork
          <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
            (h)
          </span>
          <Tooltip target=".h" position="right" event="both">
            Member (Independent Director)
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. ឯកឧត្ដម ស៊ឹម ស៊ីថា
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធាន (រដ្ឋលេខាធិការក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា
          និងនវានុវត្តន៍)
        </Tooltip>
      </p>
      <p>
        ២. ឯកឧត្ដម ម៉ី វ៉ាន់
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          សមាជិក (រដ្ឋលេខាធិការ​ក្រសួងសេដ្ឋកិច្ច និងហិរញ្ញវត្ថុ)
        </Tooltip>
      </p>
      <p>
        ៣. ឯកឧត្ដម ឡុង ណារ៉ូ
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          សមាជិក (អគ្គនាយក រ.ទ.ស.ភ)
        </Tooltip>
      </p>
      <p>
        ៤. ឯកឧត្ដម នួន ផារ័ត្ន
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          សមាជិក (អភិបាលរងនៃគណៈអភិបាលរាជធានីភ្នំពេញ)
        </Tooltip>
      </p>
      <p>
        ៥. លោក ម៉ា ណូរ៉ាវីន
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          សមាជិក (តំណាងនិយោជិត រ.ទ.ស.ភ)
        </Tooltip>
      </p>
      <p>
        ៦. លោក ណាំ ចន្ទ្រី
        <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
          (g)
        </span>
        <Tooltip target=".g" position="right" event="both">
          សមាជិក (អភិបាលមិនប្រតិបត្តិតំណាងភាគហ៊ុនិកឯកជន)
        </Tooltip>
      </p>
      <p>
        ៧. លោក ស្រេង សំឱក
        <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
          (h)
        </span>
        <Tooltip target=".h" position="right" event="both">
          សមាជិក (អភិបាលឯករាជ្យ)
        </Tooltip>
      </p>
    </>
  );
}
